import { sortByProp } from '@shared/utils/sortByProp.js';

const convertRouteGroupsToRoutes = (routeGroups) => {
  const routes = [];
  let id = 0;

  for (const [routeId, groupData] of Object.entries(routeGroups)) {
    const { element, paths, appHeader, permissions, fixedWidth, unauthenticated } = groupData;

    for (const path of paths) {
      const route = {
        routeId,
        path,
        element,
        id: id++
      };
      if (appHeader !== undefined) {
        route.appHeader = appHeader;
      }
      if (permissions !== undefined) {
        route.permissions = permissions;
      }
      if (fixedWidth !== undefined) {
        route.fixedWidth = fixedWidth;
      }
      if (unauthenticated !== undefined) {
        route.unauthenticated = unauthenticated;
      }
      routes.push(route);
    }
  }

  return routes.sort(sortByProp('routeId'));
};

export default convertRouteGroupsToRoutes;
